<template>
  <l-input
    v-model="model"
    name="lsat"
    class="field:max-w-2xs"
    size="sm"
    type="number"
    min="120"
    max="180"
    pattern="[0-9]{3}"
    placeholder="120-180"
    label="LSAT"
    help="Your highest or desired LSAT"
  />
</template>

<script setup>
import LInput from "@/components/inputs/LInput.vue"

const model = defineModel([Number, String])
</script>
